import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { RadioButtonComponent } from '@adaptiva/widgets/radio-button';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { Vector2ComponentModule } from '@adaptiva/widgets/vector2';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CloudRelayDiscoveryModeActionOverlayComponent } from './cloud-relay-discovery-mode-action-overlay.component';

@NgModule({
	imports: [
		AlertComponentModule,
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(CloudRelayDiscoveryModeActionOverlayComponent),
		RadioButtonComponent,
		SignpostComponentModule,
		TextComponentModule,
		Vector2ComponentModule,
	],
	declarations: [CloudRelayDiscoveryModeActionOverlayComponent],
	exports: [CloudRelayDiscoveryModeActionOverlayComponent]
})
export class CloudRelayDiscoveryModeActionOverlayComponentModule {

}
